import React, { useContext, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axiosInstance from "../../../utils/axiosInstance";
import { queryClient } from "../../..";
import handle401Exception from "../../../utils/handle401Exception";
import { useMutation } from "react-query";
import { GlobalContext } from "../../../utils/GlobalContext";
import { toast } from "react-hot-toast";

function DeleteLiveExamModal({ exam_id, exam_title, setDeleteModal }) {
  const { setIsAppLoading } = useContext(GlobalContext);

  const handleClose = () => {
    setDeleteModal((prev) => ({
      exam_id: null,
      exam_title: "",
    }));
  };
  const performSideEffects = () => {
    toast.success(`${exam_title} deleted successfully.`);
    queryClient.invalidateQueries({
      queryKey: ["get-live-exams"],
    });
    queryClient.invalidateQueries({
      queryKey: ["get-available-exam-sets"],
    });
    setIsAppLoading(false);
    handleClose();
  };

  const queryFunction = async () => {
    return await axiosInstance
      .delete(`/api/deleteliveexaminhousestudent/${exam_id}`)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          performSideEffects();
        }
      });
  };
  const { mutate } = useMutation(queryFunction, {
    onError: (error) => {
      setIsAppLoading(false);
      if (error?.response.status === 401) {
        handle401Exception(queryFunction, performSideEffects);
      }
      handleClose();
    },
  });
  const handleDelete = () => {
    setIsAppLoading(true);
    mutate();
  };
  return (
    <>
      <Modal show={true} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete this live exam</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure, you want to delete this live exam?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            style={{ background: "#EE4B2B", border: "none" }}
            onClick={handleDelete}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DeleteLiveExamModal;
